import { Unit, UnitBaseTypes } from "../../Units";

function Kilopound() {
  return (
    <>
      <Unit unit={UnitBaseTypes.kip} />
    </>
  );
}

export default Kilopound;
